let AP: any = null;
// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
	AP = require('simple-xdm/dist/iframe');
}

export function requireModule<Module>(name: string): Module | null | undefined {
	if (!AP) {
		return null;
	}

	let requiredModule: Module | null | undefined;

	try {
		AP.require(name, (module: Module) => {
			requiredModule = module;
		});
	} catch (e) {
		requiredModule = null;
	}

	return requiredModule;
}
